<template>
  <input
    class="input"
    :name="name"
    :type="type"
    :placeholder="placeholder"
    v-bind:value="value"
    @input="$emit('input', $event.target.value)"
    @keyup.enter="$emit('enter', $event.target.value)"
  >
</template>

<script>
export default {
  name: "Base-input",
  props: {
    label: {
      default: "unsetLabel",
      type: String
    },
    value: "",
    type: {
      default: "text",
      type: String
    },
    placeholder: {
      default: "",
      type: String
    },
    name: {
      default: "unsetFieldName",
      type: String
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/base-components/base-input.vue